<div class="modal-body bg-secondary text-white">
	<div class="d-flex justify-content-between align-items-center mx-2">
		<div class="me-3"><strong>New version of RMIS website is available.</strong></div>
		<button class="btn btn-sm btn-primary" (click)="onReload()">Update ({{ seconds }})</button>
	</div>
</div>
